import { useEffect, useRef } from "react";
import { useFinePointer, useReducedMotion } from "@/hooks/hooks";

export default function MouseGlow() {
    const ref = useRef(null);
    const fine = useFinePointer();
    const reduced = useReducedMotion();

    useEffect(() => {
        if (!fine || reduced) return;
        const el = ref.current;
        const pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
        const cur = { ...pos, o: 0.5, target: 0.5 };
        let raf;

        const onMove = (e) => {
            pos.x = e.clientX;
            pos.y = e.clientY;
        };
        const onOver = (e) => {
            cur.target = e.target.closest?.("[data-glow]") ? 0.9 : 0.5;
        };
        const loop = () => {
            raf = requestAnimationFrame(loop);
            cur.x += (pos.x - cur.x) * 0.05;
            cur.y += (pos.y - cur.y) * 0.05;
            cur.o += (cur.target - cur.o) * 0.04;
            el.style.transform = `translate3d(${cur.x}px, ${cur.y}px, 0)`;
            el.style.opacity = cur.o;
        };
        window.addEventListener("mousemove", onMove, { passive: true });
        window.addEventListener("mouseover", onOver, { passive: true });
        raf = requestAnimationFrame(loop);
        return () => {
            window.removeEventListener("mousemove", onMove);
            window.removeEventListener("mouseover", onOver);
            cancelAnimationFrame(raf);
        };
    }, [fine, reduced]);

    if (!fine || reduced) return null;
    return (
        <div ref={ref} className="pointer-events-none fixed left-0 top-0 z-0 opacity-50" aria-hidden>
            <div
                className="h-[620px] w-[620px] -translate-x-1/2 -translate-y-1/2 rounded-full"
                style={{
                    background:
                        "radial-gradient(circle, rgba(0,128,255,0.14), rgba(0,128,255,0.05) 40%, transparent 70%)",
                    filter: "blur(30px)",
                }}
            />
        </div>
    );
}
